import { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

import { FilterPopoverProps } from 'src/common/primitives/FilterPopover/FilterPopover';
import { MultiSelectFilterPopover } from 'src/common/primitives/FilterPopover/MultiSelectFilterPopover';
import { serviceTypeOptions } from 'src/features/add-trip/ServiceDetails/serviceTypeOptions';

interface ServiceTypesColumnFilterProps {
  open: boolean;
  onClose: () => void;
  selected: string[] | undefined;
  onApply: (serviceTypes: string[]) => void;
  triggerElement?: FilterPopoverProps['triggerElement'];
}

function createIdentifiedList(list: string[]): SelectOption[] {
  return list
    .map((s) => serviceTypeOptions.find((option) => option.value === s))
    .filter((option): option is SelectOption => option !== undefined);
}

export function ServiceTypesColumnFilter({
  open,
  onClose,
  selected,
  onApply,
}: ServiceTypesColumnFilterProps) {
  return (
    <MultiSelectFilterPopover
      open={open}
      value={createIdentifiedList(selected ?? []).map((option) => ({
        id: option.value,
        label: option.label,
      }))}
      filters={serviceTypeOptions.map((option) => ({
        id: option.value,
        label: option.label,
      }))}
      renderLabel={(option) => option.label}
      triggerElement={<div data-testid="service-types-column-filter-trigger" />}
      onChange={(value) => {
        onApply(value.map((option) => option.id));
        onClose();
      }}
      onCancel={onClose}
    />
  );
}
